import React, { HTMLAttributes } from 'react'

import {
  Heading,
  SocialLinkPreview,
  Text,
  theme,
} from '@hhgtech/hhg-components'
import { Carousel } from '@hhgtech/hhg-components/mantine'
import { useIsMobile } from 'hooks/useIsMobile'

import {
  StyledBabyPoopDetailVideoListWrapper,
  StyledCarousel,
} from './index.styled'

type VideoListProps = {
  title?: React.ReactNode
  description?: React.ReactNode
  videos?: {
    videoUrl: string
  }[]
} & Omit<HTMLAttributes<HTMLDivElement>, 'title'>

export const VideoList = ({
  videos,
  title,
  description,
  ...rest
}: VideoListProps) => {
  const isMobile = useIsMobile()

  if (!videos?.length || videos.length === 0) return null
  if (videos.length === 1)
    return (
      <StyledBabyPoopDetailVideoListWrapper {...rest}>
        {title &&
          (React.isValidElement(title) ? (
            title
          ) : (
            <Heading tag="h2" color={theme.colors.secondaryBase}>
              {title}
            </Heading>
          ))}
        {description && (
          <Text size="p3" style={{ marginBottom: '16px' }}>
            {description}
          </Text>
        )}
        <SocialLinkPreview url={videos[0].videoUrl || ''} autoPlay={false} />
      </StyledBabyPoopDetailVideoListWrapper>
    )
  if (videos.length === 2 && !isMobile)
    return (
      <>
        {title &&
          (React.isValidElement(title) ? (
            title
          ) : (
            <Heading
              tag="h2"
              color={theme.colors.secondaryBase}
              style={{ marginBlock: 24 }}
            >
              {title}
            </Heading>
          ))}
        {description && (
          <Text size="p3" style={{ marginBottom: '16px' }}>
            {description}
          </Text>
        )}

        <StyledBabyPoopDetailVideoListWrapper data-slide="2" {...rest}>
          {videos.map((video, index) => (
            <SocialLinkPreview
              key={index}
              url={video?.videoUrl || ''}
              autoPlay={false}
            />
          ))}
        </StyledBabyPoopDetailVideoListWrapper>
      </>
    )

  return (
    <StyledBabyPoopDetailVideoListWrapper {...rest}>
      {title &&
        (React.isValidElement(title) ? (
          title
        ) : (
          <Heading tag="h2" color={theme.colors.secondaryBase}>
            {title}
          </Heading>
        ))}
      {description && (
        <Text size="p3" style={{ marginBottom: '16px' }}>
          {description}
        </Text>
      )}

      <StyledCarousel
        slidesToShow={1.2}
        slideGap={isMobile ? 16 : 24}
        withIndicators
        controlSize={32}
        controlsOffset={5}
        draggable={false}
      >
        {videos.map((video, index) => (
          <Carousel.Slide key={index}>
            <SocialLinkPreview url={video.videoUrl || ''} autoPlay={false} />
          </Carousel.Slide>
        ))}
      </StyledCarousel>
    </StyledBabyPoopDetailVideoListWrapper>
  )
}
